// This is a manifest file that'll be compiled into including all the files listed below.

// Import Stimulus controllers
import "./controllers";

import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/brands";
import "@fortawesome/fontawesome-free/js/regular";

import "./src/jquery";
import "jquery-migrate";
import "jquery-ujs";
import "jquery_nested_form";
import "bootstrap-sass";
import "./src/highcharts";

import "leaflet";

import "chosen-js/chosen.jquery";

// This doesn't work for some reason
// import "./web/**/*.js";
import "./web/bootstrap-datepicker.js";
import "./web/colorpicker.js";
import "./web/countdown.js";
import "./web/d3.v3.js";
import "./web/events.js";
import "./web/hall_plan.js";
import "./web/input_event.js";
import "./web/intlTelInput-jquery.min.js";
import "./web/jquery.lazyload.js";
import "./web/jquery.sharrre-1.3.4.min.js";
import "./web/jquery.tagsinput.js";
import "./web/lib.js";
import "./web/nested_form.js";
import "./web/sidebar.js";
import "./web/users.js";
import "./web/share.js";

import "./carts/pf";
import "./carts/edit";
import "./src/jquery.dataTables";
import "./src/jquery.dataTables.bootstrap";
import "./src/jquery.dataTables.api.fnReloadAjax";
import "./src/admin_table_filters";
import "./src/event_search";
